import { Injectable, ViewContainerRef } from '@angular/core';

@Injectable()
export class DocumentEditScrollableElementRefService {
    public currentViewContainerRef: ViewContainerRef;

    setCurrentViewContainerRef(viewRef: ViewContainerRef) {
        this.currentViewContainerRef = viewRef;
    }
}
